import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const StyledErrorContainer = styled(Box)(({ theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '100%',
    marginBottom: '1rem',
    backgroundColor: theme.palette.error.main
  };
});

const StyledErrorMessage = styled(Typography)(({ theme }) => {
  return {
    display: 'block',
    padding: '1rem',
    fontSize: '1rem',
    fontWeight: theme.fonts.medium,
    color: theme.palette.error.contrastText
  };
});

const HAS_ORDER = 'cart already has order';
const NO_SEAT_ID = 'no seating identifier value set on the cart';
const NO_ITEMS = 'no items in the cart';

function CreateOrderErrorToast({ error }) {
  if (!error) {
    return null;
  }

  let displayMessage;
  switch (error) {
    case HAS_ORDER:
      displayMessage =
        'This cart is already associated with an order. Try refreshing the page or restarting the experience using your unique URL.';
      break;
    case NO_SEAT_ID:
      displayMessage =
        'Seat ID not set. Restart the experience using your unique URL.';
      break;
    case NO_ITEMS:
      displayMessage =
        'No items found. Try refreshing the page and re-adding items to the cart.';
      break;

    default:
      displayMessage = `${error}. Try refreshing the page or restarting the experience using your unique URL.`;
  }

  return (
    <StyledErrorContainer
      role="alert"
      aria-live="assertive"
      data-testid="error-container"
    >
      <StyledErrorMessage>{`Error placing order. ${displayMessage}`}</StyledErrorMessage>
    </StyledErrorContainer>
  );
}

CreateOrderErrorToast.propTypes = {
  error: PropTypes.string.isRequired
};

export default CreateOrderErrorToast;
